export default "__VITE_ASSET__BOiPUqZ8__"